import { Method } from 'state-line';
import { formatUrlParams, getUrlParams } from 'xgimi-utils/url';
import BaseApi from '../Base';
import ApiCode from '../../constants/ApiCode';
import { deleteObjKeys } from '../../utils/util';
import { getEnvValue } from '../../appUtils/env';
import { getStore } from '../../store';
import State from '../../store/State';

// CRM企业微信端意见反馈
export default (server: string) => ({

  // 登录校验
  GetLoginInfo: class extends BaseApi<{
    code: string;
  }> {
    method: Method = Method.Get;
    url = `${server}/h5/user/login`;
    // 接口通用失败处理
    onFail = (httpStateLine): void => {
      const state: State = getStore().getState();
      // 登录态失效时
      if (httpStateLine.result.code === ApiCode.WechatNoLogin) {
        // 跳转到企业微信获取code时去掉参数中的code和state
        const params = deleteObjKeys(getUrlParams(), ['code', 'state']);
        // eslint-disable-next-line max-len
        window.location.href = `${getEnvValue('REACT_APP_WECHAT_LOGIN')}${encodeURIComponent(`${window.location.origin}${window.location.pathname}?${formatUrlParams(params)}`)}&connect_redirect=1#wechat_redirect`;
      } else {
        state.common.toast.current?.show({ content: httpStateLine.result.message });
      }
    };
  },

  // 查询意见分类列表
  GetTypeList: class extends BaseApi<{
    // 父类编码 没传表示查询最顶层
    parentCode?: string;
  }> {
    method: Method = Method.Get;
    url = `${server}/h5/feedback/type/query`;
  },

  // 查询意见反馈列表
  GetList: class extends BaseApi<{
    currentPage?: number;
    pageSize?: number;
    feedbackTypeCode?: string;
    ownerUser?: string;
    replyStatus?: number;
    actionType?: number;
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/list`;
  },

  // 获取意见反馈详情
  GetDetail: class extends BaseApi<{
    feedbackNo?: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/detail`;
  },

  // 查询用户名字
  GetNameList: class extends BaseApi<{
    // 中文名字
    cn_name?: string;
  }> {
    method: Method = Method.Get;
    url = `${process.env.REACT_APP_OA_SERVER}/openApi/employee/matchEmployees`;
  },

  // 分配反馈
  AssignFeedback: class extends BaseApi<{
    // 反馈编号
    feedbackNo: string;
    // 被分配的人
    ownerUser?: string;
    ownerUserName?: string;
    // 意见分配编码
    feedbackTypeCode?: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/assign`;
  },

  // 回复
  Reply: class extends BaseApi<{
    // 反馈编号
    feedbackNo?: string;
    // 内容
    content?: string;
    // 回复编号
    replyNo?: string;
    imageList?: Record<string, any>[];
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/reply`;
  },

  // 完结
  Finish: class extends BaseApi<{
    feedbackNo?: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/finish`;
  },

  // 保存处理过程
  SaveDeal: class extends BaseApi<{
    // 反馈编号
    feedbackNo?: string;
    // 处理类型
    actionType?: number;
    // 处理过程
    processStatus?: number[];
    // 备注
    remark?: string;
  }> {
    method: Method = Method.Post;
    url = `${server}/h5/feedback/saveProcessInfo`;
  },

  // 查询子渠道
  QuerySubSources: class extends BaseApi<{
    // 需要查询的主来源号
    source?: number;
  }> {
    method:Method = Method.Post;
    url = `${server}/feedback/querySubSources`;
  },
});
